module.exports = "/assets/data/2db76f79b5a4f5264a62ec8ec319b84a-NE32.data.json";